<template>
    <div id="div_spRelatorio">
        <!-- ref: https://www.vue2editor.com/examples/#basic-setup -->
        <vue-editor style="height: 100%; overflow-y: auto;" id="editorRelat" v-model="content"></vue-editor>
    </div>
  </template>
 
  
// =========================================================================================
// =========================================================================================

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import { utils   } from '@/globals/utils';
import { nodes   } from '@/globals/nodes';
import { evtBus  } from '@/main';
import { VueEditor } from 'vue2-editor';


// =========================================================================================


export default {
    name : 'relatorioCMP',
    components: {
        VueEditor
    },

    // -----------------------------------------------------------------

    props: {
        active  : Boolean,
        panelId : String,
        label   : String 
    }, 

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    data () {
        return {
            content: '',
            connector : ': '
        }
    },

    // -----------------------------------------------------------------

    computed: {  
        ...mapState([
        ]),

        // -----------------------------------------------------------------

        ...mapGetters([
            'GET_activeElem',
            'GET_dentesAusentesText',
            'GET_dentesPresentes',
            'GET_teethSegTools',
            'GET_nodesArray',
            'GET_node',
            'GET_labelLocations',
        ]),

        // -----------------------------------------------------------------

        showComp() {
            return true;
        },
    },

    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
        ]),

        // -----------------------------------------------------------------

        getLabelDesc(layer, label) {            
        },

        // -----------------------------------------------------------------

        annotsPresent(layer) {
            var children = nodes.getNodeChildren(layer, this.GET_nodesArray);
            return (!children.every(child => (this.GET_labelLocations.get(child.id) == undefined))) ||
                   ([gConsts.node.report.types.NODE_LIST,
                     gConsts.node.report.types.SELECTED_NODE].includes(layer.report.type));
        },

        // -----------------------------------------------------------------

        geraRelat() {
            var locations, line,
                content = '',
                laudoTitle = 'Laudo Radiográfico',
                styles = {
                    title : 'style="text-align:center"',
                    step  : 'style="color:#06c"',
                    layer : 'style="color:#006100; padding-left:1em; padding-top:0.2em;"',
                    label : 'style="margin-left:3em;display:list-item"'
                };
            
            content = '<h1 ' + styles.title + '>' + laudoTitle + '</h2>';

            this.GET_nodesArray.forEach((node) => {
                line = null;
                switch(node.layout.type) {
                    case gConsts.node.layout.types.STEP :                        
                        content += (node.report.type == gConsts.node.report.types.SECTION) ? '<p><br></p><h2 ' + styles.step + '>' + node.report.text + '</h2>' : '';
                        break;

                    case gConsts.node.layout.types.LAYER :
                        if (this.annotsPresent(node)) {
                            switch (node.report.type) {
                                case gConsts.node.report.types.SECTION   :
                                case gConsts.node.report.types.NODE_LIST :
                                    content += '<h3 ' + styles.layer + '>' + node.report.text + '</h3>';

                                    if (node.report.type == gConsts.node.report.types.NODE_LIST) {
                                        switch (node.id) {
                                            case 'layer_dentesSeg' :                                                
                                                content += '<p ' + styles.label + '>' 
                                                if (this.GET_dentesAusentesText.length == 0) {
                                                        content += node.report.normal;
                                                } else if (this.GET_dentesPresentes.length == 0) {
                                                        content += 'Todos os Dente(s) estão ausente(s) (desdentado total).';
                                                } else {
                                                    switch (this.denticao) {
                                                        case gConsts.denticao.types.PERMANENTE : 
                                                            if (this.GET_dentesAusentesText.length < this.GET_dentesPresentes.length) {
                                                                content += 'Dente(s) ausente(s) :' + this.GET_dentesAusentesText.join(', ') + '.';
                                                            } else {
                                                                content += 'Dente(s) presente(s) :' + this.GET_dentesPresentes.join(', ') + '.';
                                                            }
                                                            break;

                                                        case gConsts.denticao.types.MISTA   :                                                         
                                                        case gConsts.denticao.types.DECIDUA : 
                                                            content += 'Dente(s) presente(s) :' + this.GET_dentesPresentes.join(', ') + '.';
                                                            break;                                                    
                                                    }
                                                }
                                                content += '</p>';
                                                break;
                                        }
                                    }
                                    break;
                                
                                case gConsts.node.report.types.SELECTED_NODE :
                                    console.log('GET_activeElem available:', this.GET_activeElem !== undefined);
                                    console.log('node.id:', node.id);

                                    content += '<h3 ' + styles.layer + '>' + node.report.text + '</h3>'
                                            + '<p ' + styles.label + '>'
                                            + nodes.getNode(this.GET_activeElem.labels[node.id]).report.text
                                            + '</p>';
                                    break;
                            }
                        }
                        break;

                    case gConsts.node.layout.types.LABEL :
                        switch (node.report.type) {
                            case gConsts.node.report.types.SELECT_OPTION : 
                                if (node.layer in this.GET_activeElem.labels) {
                                    line = node.report.text;
                                }
                                break;

                            case gConsts.node.report.types.LOCATION_LIST : 
                                locations = (this.GET_labelLocations.has(node.id) ? this.GET_labelLocations.get(node.id).join(', ') : null);
                                line = (locations ? node.report.text + ' ' + locations : null);
                                break;
                            case gConsts.node.report.types.TEXT : 
                                content += node.report.text;
                                break;
                        }

                        if (line) {                            
                            content += '<p ' + styles.label + '>' + line + '.</p>';
                        }
                        break;                    
                }
            });

            return content;           

        },

        // -----------------------------------------------------------------

        stepRelat(stepId) {
            var metais, dentes, ausentes, extranum,
                metaisProcessados = [],
                content = '';

            switch (stepId) {
                case gConsts.step.ids.DENTICAO :
                    ausentes = this.GET_dentesAusentesText,
                    extranum = this.GET_teethSegTools.filter(tool => (tool.label.id == 'lb_supranum'));
                    break;                    
                case gConsts.step.ids.PROCS  : dentes = utils.stepDentes(this.GET_procTools); break;
                case gConsts.step.ids.ANOMS  : dentes = utils.stepDentes(this.GET_anomTools); break;
                case gConsts.step.ids.METAIS : metais = this.GET_metalTools;                       break;
            }

            content = 
                '<h3><span style="color: rgb(0, 102, 204);">' + gConsts.step.texts[stepId] + '</span></h3>'
              + '<ul>';

            // parece que este código está defasado ... não usa os textos dos nodes
            // UEI !! - parece usar um gConsts.label.texts e gConsts.step.texts ??


            switch (stepId) {
                case gConsts.step.ids.DENTICAO :
                    content +=
                        '<li>' + gConsts.label.texts['Denticao'] + this.connector + this.GET_activeElem.labels[gConsts.denticao.LAYER] + '</li>'
                      + '<li>' + '[' + ausentes.length + '] Dente(s) ausente(s)' + this.connector + ausentes.join(', ') + '</li>'
                      + ((extranum.length > 0) ? '<li>' + gConsts.label.texts['Extranum'] + this.connector + '<span style="color: red;">[dentes]</span></li>' : '')
                    break;

                case gConsts.step.ids.PROCS : 
                case gConsts.step.ids.ANOMS : 
                    if (Object.keys(dentes).length > 0) {
                        for (const [key, value] of Object.entries(dentes)) {
                            content += '<li>' + gConsts.label.texts[key] + this.connector + value.join(', ') + '</li>';
                        }
                    } else {
                        content += '<li>Nenhum achado relevante.</li>';
                    }
                    break;

                case gConsts.step.ids.METAIS : 
                    if (metais.length > 0) {
                        metais.forEach(metal => {
                            if (metaisProcessados.indexOf(metal.label) == -1) {
                                content += '<li>' + gConsts.label.texts[metal.label] + this.connector + '<span style="color: red;">[listar]</span></li>';
                                metaisProcessados.push(metal.label);
                            }
                        })
                    } else {
                        content += '<li>Nenhum achado relevante.</li>';
                    }
                    break;
            }

            content += 
                '</ul>'
              + '<p><br></p>'

            return content;
        },

        // -----------------------------------------------------------------

        geraPasso(tools) {
            var dentes = utils.stepDentes(tools),
                content = '';
            
            content = '<ul>';
            if (Object.keys(dentes).length > 0) {
                for (const [key, value] of Object.entries(dentes)) {
                    content += '<li>' + gConsts.label.texts[key] + this.connector + value.join(', ') + '</li>';
                }
            } else {
                content += '<li>Nenhum achado relevante.</li>';
            }
            content += '</ul>';

            return content;            
        }        
    },

    // =========================================================================================
    // Lifecycle hooks

    created() {
        evtBus.$on('evt_panelActivation', (panelId) => {
            if (panelId == this.panelId) {
                this.content = this.geraRelat();
            }
        });        
    }
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
.stepLine {
    color : #06c
}

.layerLine {
    color : #006100;
    padding-left : 1em;
}

.labelLine {
    padding-left : 2em;
    margin-top : 0.2em;
    display: list-item;
    list-style-type: disc;     
    list-style-position: inside;
}

</style>